import { render, staticRenderFns } from "./LookCampusInfo.vue?vue&type=template&id=1bb51674&scoped=true&"
import script from "./LookCampusInfo.vue?vue&type=script&lang=js&"
export * from "./LookCampusInfo.vue?vue&type=script&lang=js&"
import style0 from "./LookCampusInfo.vue?vue&type=style&index=0&id=1bb51674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb51674",
  null
  
)

export default component.exports